module.exports = __webpack_public_path__ + "media/video_banner_principal.5c821ef8.mp4";